import script from "./Agents.vue?vue&type=script&setup=true&lang=js"
export * from "./Agents.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Agents.vue?vue&type=style&index=1&id=8fdf690c&lang=css"

const __exports__ = script;

export default __exports__